/**
 * Secure File Download Utilities
 * 
 * SEC-01 FIX: Все загрузки файлов через Authorization header, 
 * никаких токенов в URL.
 */
import { api } from '@/contexts/AuthContext';

/**
 * Download file as blob and trigger browser download
 * @param {string} fileId - File ID
 * @param {string} filename - Suggested filename for download
 */
export async function downloadFile(fileId, filename = 'download') {
  const response = await api.get(`/files/${fileId}/download`, {
    responseType: 'blob'
  });
  
  const blob = new Blob([response.data], { 
    type: response.headers['content-type'] || 'application/octet-stream' 
  });
  
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Load image as blob URL for secure display
 * @param {string} fileId - File ID
 * @returns {Promise<string>} - Blob URL for img src
 */
export async function getSecureImageUrl(fileId) {
  try {
    const response = await api.get(`/files/${fileId}/download`, {
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { 
      type: response.headers['content-type'] || 'image/jpeg' 
    });
    
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Failed to load secure image:', error);
    return null;
  }
}

/**
 * Open file in new tab (for PDFs, images, etc.)
 * @param {string} fileId - File ID
 * @param {string} contentType - MIME type of file
 */
export async function openFileInNewTab(fileId, contentType = 'application/pdf') {
  const response = await api.get(`/files/${fileId}/download`, {
    responseType: 'blob'
  });
  
  const blob = new Blob([response.data], { type: contentType });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  
  // Revoke after a delay to allow the new tab to load
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
